import type { FC } from 'react';

/*
 * KeyInfo
 * 사용 영역: 국내숙소, 레저, 해외숙소
 * 타입 정보: Banner, List
 */

export interface UnitKeyInfoProps {
  title: string;
  newRegistered?: string | null;
  category?: string | null;
  adText?: string | null;
}

export const UnitKeyInfo: FC<UnitKeyInfoProps> = ({ title, newRegistered = '', category = '', adText = '' }) => {
  return (
    <div className="py-2">
      {/*  카테고리명과 신규입점(국내숙소한정) 둘다 없을경우 노출하지 않음  */}
      {!!(newRegistered || category || adText) && (
        <div className="mb-4 flex gap-4">
          {!!newRegistered && <span className="text-text-accent-medium typography-body-12-bold">{newRegistered}</span>}
          {!!category && <p className="text-text-neutral-sub typography-body-12-regular">{category}</p>}
          {!!adText && (
            <span className="ml-auto text-text-neutral-medium opacity-60 typography-label-10-bold">{adText}</span>
          )}
        </div>
      )}
      <p className="mb-4 line-clamp-2 text-start text-fill-neutral-main typography-subtitle-16-bold">{title}</p>
    </div>
  );
};

export const UnitCardKeyInfo: FC<UnitKeyInfoProps> = ({ newRegistered = '', category = '', title }) => {
  return (
    <div className="py-2">
      {/*  카테고리명과 신규입점(국내숙소한정) 둘다 없을경우 노출하지 않음  */}
      {!!(newRegistered || category) && (
        <div className="mb-4 flex gap-4">
          {!!newRegistered && (
            <span className="text-text-accent-medium typography-caption-11-bold">{newRegistered}</span>
          )}
          {!!category && <p className="text-text-neutral-sub typography-caption-11-regular">{category}</p>}
        </div>
      )}
      <p className="line-clamp-2 text-start text-fill-neutral-main typography-body-14-bold">{title}</p>
    </div>
  );
};
